var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"label":"Cidade","dense":"","outlined":"","loading":_vm.loading,"items":_vm.items,"item-text":"city_formatted","item-value":"ibge_code","name":"city","hide-no-data":"","clearable":""},on:{"update:search-input":_vm.search}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }